import branding from './branding';
import seo from './seo';

export default {
  branding,
  seo,
  components: {
    logo: {
      url: () => require('./static/theme-logo.svg'),
      light: '#FFFFFF',
      dark: '#0A0E4D',
    },
  },
};
